import {Button, Column, Row, Select, Spinner, Text, TextInput} from "react-vcomponents";
import {BaseComponentWithConnector, BaseComponentPlus, BaseComponent} from "react-vextensions";
import {ScrollView} from "react-vscrollview";
import {GetSounds} from "../../Server/DB/sounds.js";
import {MeID} from "../../Server/DB/users.js";
import {GetYoutubePlayersToKeepBuffered} from "../../Store/main/engine/sounds.js";
import {InfoButton, PageContainer, Observer, RunInAction_Set} from "web-vcore";
import {ES} from "web-vcore";
import {GetEntities} from "../../Server/DB/entities.js";
import {ShowSignInPopup} from "../@Shared/NavBar/UserPanel.js";
import {ShowAddEntityDialog} from "./Entities/EntityDetailsUI.js";
import {TagTargetEntryUI} from "../@Shared/TagTargetEntryUI.js";
import {useState} from "react";
import React from "react";
import {observer_mgl} from "mobx-graphlink";
import {store} from "../../Store/index.js";
import {GetEntries} from "js-vextensions";
import {EntityPool} from "../../Store/main/content.js";

export const columnWidths = [.25, .1, .1, .3, .25];

export const EntitiesUI = observer_mgl((props: {})=>{
	const uiState = store.main.content.entities;
	const entities_raw = GetEntities(uiState.entityPool).filter(a=>a && a.creator == MeID()); // defensive (temp)
	const userID = MeID();

	const entities = entities_raw.filter(entity=>{
		if (entity.name.toLowerCase().includes(uiState.filter.toLowerCase())) return true;
		if (entity.tags.Any(a=>a.toLowerCase().includes(uiState.filter.toLowerCase()))) return true;
		return false;
	});

	return (
		<PageContainer style={{margin: "20px auto 20px auto", padding: 0}}>
			<Column className="clickThrough" style={{height: 80, borderRadius: "10px 10px 0 0"}}>
				<Row center style={{height: 40, padding: 10}}>
					<Select displayType="button bar" options={GetEntries(EntityPool, "ui")} value={uiState.entityPool} onChange={val=>RunInAction_Set(()=>uiState.entityPool = val)}/>
					<Text ml={5}>Filter:</Text>
					<TextInput ml={5} style={{width: 200}} instant value={uiState.filter} onChange={val=>RunInAction_Set(()=>uiState.filter = val)}/>
					<Button text={`Add entity (${uiState.entityPool})`} ml="auto" onClick={()=>{
						if (MeID() == null) return ShowSignInPopup();
						ShowAddEntityDialog(uiState.entityPool);
					}} />
				</Row>
				<Row style={{height: 40, padding: 10}}>
					<Text style={{flex: columnWidths[0], fontWeight: 500, fontSize: 16}}>Name</Text>
					<Text style={{flex: columnWidths[1], fontWeight: 500, fontSize: 16}}>Preview</Text>
					<Text style={{flex: columnWidths[2], fontWeight: 500, fontSize: 16}}>Creator</Text>
					<Text style={{flex: columnWidths[3], fontWeight: 500, fontSize: 16}}><Text>Tags (click tags to </Text><span style={{color: "rgba(100,200,100,.7)"}}>accept</span>)</Text>
					<Text style={{flex: columnWidths[4], fontWeight: 500, fontSize: 16}}></Text>
				</Row>
			</Column>
			<ScrollView style={ES({flex: 1})} contentStyle={ES({flex: 1})}>
				{entities.length == 0 && <div style={{textAlign: "center", fontSize: 18}}>No entries.</div>}
				{entities.map((entity, index)=>{
					return <TagTargetEntryUI key={index} index={index} last={index == entities.length - 1} group="entities" entry={entity} localOnly={uiState.entityPool == EntityPool.local}/>;
				})}
			</ScrollView>
		</PageContainer>
	);
});